module.exports = __webpack_public_path__ + "img/admin-price-levels.a8f3f0dc.webp";